module.exports = __webpack_public_path__ + "static/media/charts.226c8179.gif";